import React from 'react';

const AdvancedIvfLabPatternTab = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 744 704" fill="none">
      <g clip-path="url(#clip0_418_4527)">
        <rect width="744" height="704" fill="white" />
        <g opacity="0.53">
          <rect x="387.482" y="11" width="14.5839" height="41" fill="#DDCAEB" />
          <rect x="415" y="23.9331" width="14.5839" height="41" transform="rotate(90 415 23.9331)" fill="#DDCAEB" />
        </g>
        <g opacity="0.53">
          <rect x="514.268" y="517" width="31.6577" height="89" fill="#DDCAEB" />
          <rect x="574" y="545.074" width="31.6577" height="89" transform="rotate(90 574 545.074)" fill="#DDCAEB" />
        </g>
        <g opacity="0.53">
          <rect x="39.2676" y="-13" width="31.6577" height="89" fill="#DDCAEB" />
          <rect x="99" y="15.0737" width="31.6577" height="89" transform="rotate(90 99 15.0737)" fill="#DDCAEB" />
        </g>
        <g opacity="0.61" filter="url(#filter0_d_418_4527)">
          <path d="M648.955 97.3708C545.293 110.011 505.126 34.3903 498 -5H744V153C729.793 113.5 674.717 99.4556 648.955 97.3708Z" fill="#7F4A9B" />
        </g>
        <g opacity="0.4" filter="url(#filter1_d_418_4527)">
          <path d="M135.703 477.017C77.2466 485.315 20.8774 451.797 0 434V704H744C716.315 685.186 651.104 645.79 617.7 648.475C584.296 651.159 545.688 651.831 530.56 651.831C478.638 651.342 428.744 597.119 410.287 570.068C397.579 536.142 363.842 505.695 348.563 494.712C307.171 464.447 189.41 470.305 135.703 477.017Z" fill="#7F4A9B" />
        </g>
        <g opacity="0.53">
          <rect x="660.268" y="276" width="31.6577" height="89" fill="#DDCAEB" />
          <rect x="720" y="304.074" width="31.6577" height="89" transform="rotate(90 720 304.074)" fill="#DDCAEB" />
        </g>
        <g opacity="0.53">
          <rect x="29.2676" y="219" width="31.6577" height="89" fill="#DDCAEB" />
          <rect x="89" y="247.074" width="31.6577" height="89" transform="rotate(90 89 247.074)" fill="#DDCAEB" />
        </g>
        <g opacity="0.53">
          <rect x="676.482" y="577" width="14.5839" height="41" fill="#DDCAEB" />
          <rect x="704" y="589.933" width="14.5839" height="41" transform="rotate(90 704 589.933)" fill="#DDCAEB" />
        </g>
      </g>
      <defs>
        <filter id="filter0_d_418_4527" x="478" y="-16" width="286" height="198" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="9" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_418_4527" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_418_4527" result="shape" />
        </filter>
        <filter id="filter1_d_418_4527" x="-16" y="413" width="786" height="312" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="5" />
          <feGaussianBlur stdDeviation="10.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_418_4527" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_418_4527" result="shape" />
        </filter>
        <clipPath id="clip0_418_4527">
          <rect width="744" height="704" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AdvancedIvfLabPatternTab;